module.exports = __webpack_public_path__ + "static/media/SF_nn_primaerlogo_nordland_pos.e1fc9b32.pdf";